import { render, staticRenderFns } from "./DoctorAssistantRelationModal__Style#Drawer.vue?vue&type=template&id=29262d66&scoped=true&"
import script from "./DoctorAssistantRelationModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./DoctorAssistantRelationModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./DoctorAssistantRelationModal__Style#Drawer.vue?vue&type=style&index=0&id=29262d66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29262d66",
  null
  
)

export default component.exports